import { render } from "./TitleHead.vue?vue&type=template&id=752022ea&scoped=true"
import script from "./TitleHead.vue?vue&type=script&lang=js"
export * from "./TitleHead.vue?vue&type=script&lang=js"

import "./TitleHead.vue?vue&type=style&index=0&id=752022ea&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752022ea"]])

export default __exports__